import { action } from 'satcheljs';

export const showNotificationPermissionsOverlay = action('showNotificationPermissionsOverlay');
export const dismissNotificationPermissionsOverlay = action(
    'completeNotificationPermissionsOverlay'
);
